import { Button, FormHelperText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { getUrls } from '../../../../../utils/url';

const StyledLabelFieldDiv = styled.div`
    display: flex;
    flex-direction: column;
`;
const UrlDiv = styled.div`
    margin-top: 24px;
    display: flex;
    align-items: center;
`;

const CopyButton = styled(Button)`
    margin-left: 12px;
`;

interface UrlProps {
    path?: string;
}

const URLValue = (props: UrlProps) => {
   const { path } = props;
    const { t } = useTranslation('admin_settings');
    const { api } = getUrls();
    const url = path ? `${api}${path}` : `${api}/lti/course`;
    return (
        <UrlDiv>
            <StyledLabelFieldDiv>
                <Typography>{t('url')}</Typography>
                <FormHelperText>
                    {url}
                </FormHelperText>
            </StyledLabelFieldDiv>
            <CopyButton variant='outlined' onClick={() => navigator.clipboard.writeText(url)}>{t('copy')}</CopyButton>
        </UrlDiv>
    );
};

export default URLValue;
